import React, { useEffect, useState, useContext } from "react";
import { toast } from "react-toastify";
import { Col, Row } from "reactstrap";
import AppContext from "../../../context/Context";
import apiCall from "../../../services/apiCall";
import APICall from "../../../services/apiCall";
import TeamMember from "../../admin-user-common/TeamMember";
import APIAccessDetails from "../../admin/partnerDetails/APIAccessDetails";
import ApiConsentfromAdminToPartner from "../../admin/partnerDetails/ApiConsentfromAdminToPartner";
import ApplicationDetails from "../../admin/partnerDetails/ApplicationDetails";
import PartnerCustomerList from "../../admin/partnerDetails/PartnerCustomerList";
import FreshDeskPartnerTicketsStats from "../../admin/partnerDetails/FreshDeskPartnerTicketsStats";
import HubspotTechnicalSupportDetails from "../../admin-user-common/Hubspot/HubspotTechnicalSupportDetails";
import PaymentLiveUpdateConfiguration from "../../admin/partnerDetails/PaymentVersionReleaseTable";
import ModalCustom from "../../common/ModalCustom";

const ApplicationsDetails = ({ actions }) => {
  const [appid, setAppid] = useState("");
  const [applicationDetails, setApplicationDetails] = useState({});
  const [partnerDetails, setPartnerDetails] = useState({});
  const [applicationList, setApplicationList] = useState([]);
  const [getApiData, setGetApiData] = useState([]);
  const { loginUserDetails } = useContext(AppContext);
  const [isShow, setIsShow] = useState(false);
  const [
    showApiAccessButtonClickedCancel,
    setShowApiAccessButtonClickedCancel,
  ] = useState(false);
  const [selectedApiNames, setSelectedApiNames] = useState([]);
  const [apiLimitNote, setApiLimitNote] = useState("");
  const [fetchApplicationDetails, setFetchApplicationDetails] = useState(false);
  const [isRefreshAPIConsent, setIsRefreshAPIConsent] = useState(false);
  const [fetchApiAccessList, setFetchApiAccessList] = useState(false);
  const [hubspotOwner, setHubspotOwner] = useState("");
  const [showHubspotOwnerCard, setShowHubspotOwnerCard] = useState(true);
  // useState variable This variable is only used for NadaPayment Application
  // If you want to add another Partner for Live UPdate feature please make neccsary change with this variable
  const [
    partnerCustomerListForLiveUpdate,
    setPartnerCustomerListForLiveUpdate,
  ] = useState(true);
  const isActionAllowed = (actionName) => {
    // let particularAction = actions.handlers.find((aName) => aName === actionName);
    // if (particularAction) return true;
    // else return false;
  };

  useEffect(() => {
    var apiParam = { devid: loginUserDetails.parent_dev_id };
    APICall.servertrip(
      "GET",
      "partner_details_user",
      loginUserDetails,
      apiParam
    ).then(
      (res) => {
        setPartnerDetails(res.data.items[0]);
      },
      (error) => {
        const resMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        toast.error(resMessage);
      }
    );
  }, []);

  const [quoteIds, setQuoteIds] = useState([]);
  const [quoteExpirations, setQuoteExpirations] = useState([]);
  const [showContractExpiringModal, setShowContractExpiringModal] = useState(
    false
  );
  const [nearestExpiringDate, setNearestExpiringDate] = useState(null);
  const [daysToExpire, setDaysToExpire] = useState(null);

  // hubspotcompanies
  const fetchHubspotCompanies = () => {
    const param = {
      company_id: loginUserDetails?.crm_id,
      user_dev_id: loginUserDetails.dev_id,
    };
    apiCall
      .servertrip("GET", "hubspotcompanies", undefined, param)
      .then((res) => {
        let data = res.data.items;
        setHubspotOwner(data.company_property.owner_id);

        // --- Start: Get associated deal IDs and call second API ---
        const hubspotDealsData = data.associations?.deals?.results || [];

        // Optional: Remove duplicate deal IDs
        const uniqueDealIds = [
          ...new Set(hubspotDealsData.map((deal) => deal.deal_id)),
        ];

        if (uniqueDealIds.length > 0) {
          fetchHubspotDeal(uniqueDealIds);
        }
      })
      .catch((error) => {});
  };

  //hubspotdeal
  const fetchHubspotDeal = (uniqueDealIds) => {
    let apiParam = {
      deal_id: uniqueDealIds.join(","),
      user_dev_id: loginUserDetails.dev_id,
    };

    apiCall
      .servertrip("GET", "hubspotdeal", loginUserDetails, apiParam)
      .then((res) => {
        const allQuoteIds = res.data.items
          .flatMap((item) => item.associations?.quotes?.results || [])
          .map((quote) => quote.quotes_id);

        // setQuoteIds(allQuoteIds);
        if (allQuoteIds.length > 0) {
          fetchHubspotQuote(allQuoteIds);
        }
      })
      .catch((error) => {});
  };

  //hubspotquote
  const fetchHubspotQuote = (allQuoteIds) => {
    let quoteApiParam = {
      quote_id: allQuoteIds.join(","),
      user_dev_id: loginUserDetails.dev_id,
    };
    apiCall
      .servertrip("GET", "hubspotquote", loginUserDetails, quoteApiParam)
      .then((res) => {
        const quoteItems = res.data.items;
        const upcomingExpirations = quoteItems
          .map((q) => new Date(q.quote_property?.expiration_date))
          .filter((date) => !isNaN(date) && date > new Date());

        if (upcomingExpirations.length > 0) {
          const nearestDate = upcomingExpirations.sort((a, b) => b - a)[0];
          const today = new Date();
          const daysRemaining = getDayDifference(today, nearestDate);
          if (daysRemaining <= 30) {
            setNearestExpiringDate(nearestDate);
            setDaysToExpire(daysRemaining);
            //setShowContractExpiringModal(true);
          }
        }
      })
      .catch((error) => {
        console.error("Error fetching quotes:", error);
        setquoteTableLoading(false);
      });
  };

  useEffect(() => {
    let value = localStorage.getItem("contractExpiryModel");
    if (
      loginUserDetails.is_partner == "1" &&
      loginUserDetails.crm_id &&
      value &&
      value == "true"
    ) {
      fetchHubspotCompanies();
    }
  }, []);

  const contractModelClose = () => {
    setShowContractExpiringModal(false);
    localStorage.removeItem("contractExpiryModel");
  };
  const selectApplicationDetails = (
    appDetails,
    appName,
    appKey,
    appId,
    selectedOption
  ) => {
    setApplicationDetails(appDetails);
    // setApplicationName(appName);
    // setApplicationSecretKey(appKey);
    setAppid(appId);
  };

  useEffect(() => {
    if (appid !== "") {
      setIsShow(false);
      let useParam = {
        app_id: `${appid}`,
        dev_id: `${loginUserDetails.parent_dev_id}`,

        status: "sent",
      };
      apiCall
        .servertrip(
          "GET",
          "get_consent_apis_for_application",
          loginUserDetails,
          useParam
        )
        .then((res) => {
          setGetApiData(res.data.items);
          if (res.data.items.length > 0) {
            setIsShow(true);
          }

          // toast.success(res.data.message);
        })
        .catch((error) => {
          toast.error(error.data);
          setIsShow(false);
        });
    }
  }, [appid, loginUserDetails.parent_dev_id, isRefreshAPIConsent]);

  useEffect(() => {
    localStorage.setItem("partner_logo", partnerDetails?.partner_logo);
  }, [partnerDetails]);

  return (
    <>
      <ModalCustom
        isOpen={showContractExpiringModal}
        setOpenPopup={contractModelClose}
        // toggle={onDismissAccountRecovery}
        title="Contract Expiry Reminder"
        size="md"
        centered
        fade={false}
        backdrop={"static"}
        // isHeaderCloseBtn={false}
        keyboard={false}
      >
        <Row>
          <Col>
            <h5 className="text-danger mb-3">Your API License will expire soon</h5>

            <h5 className="text-dark mb-3">
              Hi {loginUserDetails?.partner_name}
            </h5>

            <h6 className="text-body mb-3">
              <strong>Reminder:</strong> Your API License will expire in{" "}
              <span className="text-danger">
                {daysToExpire} day{daysToExpire > 1 ? "s" : ""}
              </span>{" "}
              on{" "}
              <span className="font-weight-bold">
                {nearestExpiringDate?.toDateString()}
              </span>
              
            </h6>

            <h6 className="text-body mb-3" style={{ lineHeight: "inherit" }}>
              To avoid disruption, please renew it before the expiry date.
              <br />
              <strong>Contact your Sikka Customer Support Manager</strong> for
              assistance.
            </h6>
          </Col>
        </Row>
      </ModalCustom>

      <div style={{ overflowX: "hidden" }}>
        <Row noGutters>
          <Col lg={12} xl={12} className="pr-0 pr-lg-0 pr-xl-2">
            <ApplicationDetails
              devid={loginUserDetails.parent_dev_id}
              selectApplicationDetails={selectApplicationDetails}
              isActionAllowed={isActionAllowed}
              setApplicationID={setAppid}
              setApplicationList={setApplicationList}
              applicationList={applicationList}
              showApiAccessButtonClickedCancel={
                showApiAccessButtonClickedCancel
              }
              setShowApiAccessButtonClickedCancel={
                setShowApiAccessButtonClickedCancel
              }
              selectedApiNames={selectedApiNames}
              setSelectedApiNames={setSelectedApiNames}
              apiLimitNote={apiLimitNote}
              setApiLimitNote={setApiLimitNote}
              fetchApplicationDetails={fetchApplicationDetails}
              setFetchApplicationDetails={setFetchApplicationDetails}
              partnerDetails={partnerDetails}
              setFetchApiAccessList={setFetchApiAccessList}
            />
          </Col>
          <HubspotTechnicalSupportDetails
            hubspotOwner={hubspotOwner}
            setShowHubspotOwnerCard={setShowHubspotOwnerCard}
            showHubspotOwnerCard={showHubspotOwnerCard}
          />
          <Col lg={12} xl={12} className="pr-0 pl-lg-0 mb-1">
            <APIAccessDetails
              applicationDetails={applicationDetails}
              appid={appid}
              isActionAllowed={isActionAllowed}
              applicationList={applicationList}
              showApiAccessButtonClickedCancel={
                showApiAccessButtonClickedCancel
              }
              setShowApiAccessButtonClickedCancel={
                setShowApiAccessButtonClickedCancel
              }
              selectedApiNames={selectedApiNames}
              setSelectedApiNames={setSelectedApiNames}
              apiLimitNote={apiLimitNote}
              setApiLimitNote={setApiLimitNote}
              fetchApiAccessList={fetchApiAccessList}
              setFetchApiAccessList={setFetchApiAccessList}
            />
          </Col>
        </Row>

        <Row noGutters className="mt-12">
          <Col>
            <PartnerCustomerList
              devid={loginUserDetails.parent_dev_id}
              appid={appid}
              isActionAllowed={isActionAllowed}
              applicationDetails={applicationDetails}
              applicationList={applicationList}
              setPartnerCustomerListForLiveUpdate={
                setPartnerCustomerListForLiveUpdate
              }
            />
          </Col>
        </Row>
        {appid == "bee90a7b475b06f198dd0e418451cbc1" && (
          <Row noGutters className="mt-12">
            <Col>
              <PaymentLiveUpdateConfiguration
                appid={appid}
                isActionAllowed={isActionAllowed}
                applicationDetails={applicationDetails}
                applicationList={applicationList}
                partnerCustomerListForLiveUpdate={
                  partnerCustomerListForLiveUpdate
                }
              />
            </Col>
          </Row>
        )}
        {/* {loginUserDetails?.freshdesk_id && (
        <FreshDeskPartnerTicketsStats
          FreshDeskId={loginUserDetails?.freshdesk_id}
        />
      )} */}
        {isShow && applicationList.length > 0 && (
          <ApiConsentfromAdminToPartner
            devid={loginUserDetails.dev_id}
            appid={appid}
            GetApiData={getApiData}
            setIsRefreshData={setIsRefreshAPIConsent}
            IsRefreshData={isRefreshAPIConsent}
            applicationDetails={applicationDetails}
            applicationList={applicationList}
            loginUserDetails={loginUserDetails}
          />
        )}
        {loginUserDetails.user_type.toLowerCase() === "user" ? (
          <div />
        ) : (
          <Row noGutters>
            <Col>
              <TeamMember
                parent_devid={loginUserDetails.parent_dev_id}
                isActionAllowed={isActionAllowed}
                partnerDetails={partnerDetails}
              />
            </Col>
          </Row>
        )}
      </div>
    </>
  );
};

export default ApplicationsDetails;

function getDayDifference(date1, date2) {
  const msDate1 = new Date(date1).getTime();
  const msDate2 = new Date(date2).getTime();
  const diffInMs = msDate2 - msDate1;
  const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
  return diffInDays;
}
